import { WeatherSunsetUpIcon } from './WeatherSunsetUpIcon';

/**
 * author: Austin Andrews
 * id AC82F126-0773-44CE-A004-77E7DDD130C9
 * name weather-sunset-up
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/weather-sunset-up.svg
 * tags
 * - Weather 
 */
export const SunriseIcon = WeatherSunsetUpIcon;
export default SunriseIcon